import { NoPermissionState } from "@/components/common/no-permission-state";
import { isForbiddenError } from "@/lib/clinic-grants";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  PageEyebrowLink,
  PageHeader,
  Button,
  Skeleton,
} from "@/components/ui";
import { BudgetDataTable, FormBudgets } from "@/components/common";
import { useFetchBudgetsQuery, usePermission } from "@/hooks";

export function Budgets() {
  const { t } = useTranslation();
  const { checkPermission } = usePermission();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const perPageParam = searchParams.get("per_page");

  const [perPage, setPerPage] = useState<number>(
    perPageParam ? Number(perPageParam) : 10
  );

  const { data: budgetsData, isLoading, error: listError } = useFetchBudgetsQuery({
    page,
    per_page: perPage,
  });

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("per_page", newPerPage.toString());
    setSearchParams(newSearchParams);
  };

  // SEC-GATES-02: a refusal from the list endpoint is stated, not shown as an empty list.
  if (isForbiddenError(listError)) return <NoPermissionState />;

  return (
    <section className="space-y-7">
      <PageHeader
        eyebrow={
          <PageEyebrowLink to="/financial/account">
            {t("LABEL.financial")}
          </PageEyebrowLink>
        }
        title={t("LABEL.budgets")}
        lede="O que foi orçado para cada paciente e em que pé está a aprovação."
        actions={
          <FormBudgets>
            <Button
              variant="petrol"
              size="lg"
              className="px-5"
              disabled={!checkPermission("budget", "create budgets")}
            >
              {t("LABEL.new")}
            </Button>
          </FormBudgets>
        }
      />
      <div className="space-y-2">
        {!budgetsData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <BudgetDataTable
            perPage={perPage}
            handlePerPageChange={handlePerPageChange}
            data={budgetsData}
          />
        )}
      </div>
    </section>
  );
}
